import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  link: PropTypes.shape({
    defaultMessage: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    // all desired <a/> attributes, except for `href`
    props: PropTypes.shape({}).isRequired,
  }).isRequired,
  description: PropTypes.shape({
    defaultMessage: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
};

// react-intl injects the localized value into a child function, which is what renders.
// this way we can use locale-specific hrefs.
const LocalizedLink = ({ link, description }) => (
  <FormattedMessage
    id={link.key}
    defaultMessage={link.defaultMessage}
  >
    {
      href => React.createElement(
        'a',
        { ...link.props, href },
        <FormattedMessage
          id={description.key}
          defaultMessage={description.defaultMessage}
        />,
      )
    }
  </FormattedMessage >
);

LocalizedLink.propTypes = propTypes;

export default LocalizedLink;
